import { Status1, DiscreteCode, ContinuousCode } from './Status1';

/**
 * Type guard to check if a string is a valid DiscreteCode
 * @param code - The code to check
 * @returns True if the code is a valid DiscreteCode
 */
export function isValidDiscreteCode(code: string): code is DiscreteCode {
  return ['g', 'r', 'y', 'G', 'R', 'Y', 'p', '?', ''].includes(code);
}

/**
 * Type guard to check if a string is a valid ContinuousCode
 * @param code - The code to check
 * @returns True if the code is a valid ContinuousCode (r1-r6, y7-y12, g13-g22)
 */
export function isValidContinuousCode(code: string): code is ContinuousCode {
  const continuousCodes: ContinuousCode[] = [
    'r1',
    'r2',
    'r3',
    'r4',
    'r5',
    'r6',
    'y7',
    'y8',
    'y9',
    'y10',
    'y11',
    'y12',
    'g13',
    'g14',
    'g15',
    'g16',
    'g17',
    'g18',
    'g19',
    'g20',
    'g21',
    'g22',
  ];
  return continuousCodes.includes(code as ContinuousCode);
}

/**
 * Check if a status is metric-oriented (continuous codes)
 *
 * @param status - The status object to check
 * @returns True if the status uses continuous codes (metric-oriented)
 */
export function isStatusOfMetric(status: Status1): boolean {
  return isValidContinuousCode(status.statusCode);
}

/**
 * Check if a status is deliverable-oriented (discrete codes)
 * Infers from statusCode format rather than deprecated statusType field
 * @param status - The status object to check
 * @returns True if the status uses discrete codes (deliverable-oriented)
 */
export function isStatusOfDeliverable(status: Status1): boolean {
  return isValidDiscreteCode(status.statusCode);
}
